import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-efd18158"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "frontend",
  class: "mb-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Proyectos Front-end", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-mono-label text-xs uppercase tracking-[0.14em] text-subtle -mt-4 mb-8" }, " Proyectos personales ", -1))
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "font-serif-display text-xl text-ink mb-1" }
const _hoisted_8 = { class: "text-subtle text-sm leading-relaxed mb-2" }
const _hoisted_9 = { class: "font-mono-label text-[0.7rem] uppercase tracking-[0.08em] text-indigo2 mb-3" }
const _hoisted_10 = ["href"]

import { ref } from 'vue';

interface Proyecto {
  titulo: string;
  descripcion: string;
  imagen: string;
  tecnologias: string[];
  enlace: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProyectosFrontend',
  setup(__props) {

const proyectos = ref<Proyecto[]>([
  {
    titulo: 'Forum Challenge Alura',
    descripcion: 'Crea tópicos de diferentes cursos y responde a los tópicos de otros usuarios.',
    imagen: require('@/assets/frontend_foro.png'),
    tecnologias: ['Vue.js', 'TypeScript', 'Tailwind CSS', 'Vuex'],
    enlace: 'https://forumcourses.netlify.app',
  },
  {
    titulo: 'Voll Clinic Frontend',
    descripcion: 'Interfaz de usuario para la aplicación de gestión de clínica médica.',
    imagen: require('@/assets/frontend_clinic.png'),
    tecnologias: ['React', 'TypeScript', 'Material UI', 'Redux'],
    enlace: 'https://vollclinic.netlify.app',
  },
  {
    titulo: 'Encriptador de Texto',
    descripcion: 'Aplicación web para cifrar y descifrar mensajes de texto.',
    imagen: require('@/assets/encriptador.png'),
    tecnologias: ['JavaScript', 'HTML5', 'CSS3'],
    enlace: 'https://encriptador.netlify.app',
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proyectos.value, (proyecto, index) => {
        return (_openBlock(), _createElementBlock("article", {
          key: index,
          class: "group"
        }, [
          _createElementVNode("a", {
            href: proyecto.enlace,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "block border border-hairline rounded-sm overflow-hidden mb-4"
          }, [
            _createElementVNode("img", {
              src: proyecto.imagen,
              alt: proyecto.titulo,
              class: "w-full h-44 object-cover object-top grayscale-[35%] group-hover:grayscale-0 transition-all duration-500"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(proyecto.titulo), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(proyecto.descripcion), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(proyecto.tecnologias.join(' · ')), 1),
          _createElementVNode("a", {
            href: proyecto.enlace,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "text-sm font-semibold text-ink border-b border-ink pb-0.5 hover:text-indigo2 hover:border-indigo2 transition-colors"
          }, " Ver proyecto → ", 8, _hoisted_10)
        ]))
      }), 128))
    ])
  ]))
}
}

})